import React, { useEffect, useRef, Fragment } from "react";
import { Formik } from "formik";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import {
  getCtxAppAndMerchantAccountUUID,
  getCtxAppResourceAndIDs
} from "utils/mapStateToProps";
import { createMerchantAccountPrices } from "actions/price";
import isEmpty from "lodash/isEmpty";
import {
  prepareCreatePrices,
  getCreatePricesInitialValues,
  validatePriceSchema
} from "utils/price";
import ProductPriceFormList from "../ProductPriceFormList";
import { withRouter } from "next/router";
import Padder from "components/Padder";
import { useProduct } from "utils/selectors";
import MenuNavHeader from "components/MenuNavHeader";

const DEFAULT_CLASSES = {
  priceList: "bg-white bh--inset h-100 pt3 ph3",
  navHeader: {
    label: "fw6 f3 word-break"
  }
};

const ProductNewPriceForm = ({
  hidePadder,
  goBack,
  uid,
  scrollTop,
  resourceUUID,
  resource,
  merchantAccountUUID,
  actions,
  customClasses
}) => {
  const classes = {
    ...DEFAULT_CLASSES,
    ...customClasses
  };
  const product = useProduct(uid);
  const formRef = useRef(null);
  useEffect(() => {
    scrollTop && scrollTop();
    if (formRef && formRef.current) {
      formRef.current.validateForm();
    }
  }, []);

  const createPrices = (formValues, formikActions) => {
    actions.createMerchantAccountPrices(
      {
        resourceUUID,
        resource,
        uuid: merchantAccountUUID,
        data: prepareCreatePrices(formValues.prices)
      },
      (err, _) => {
        formikActions.setSubmitting(false);
        if (err) {
          formikActions.setErrors(err);
        } else {
          formikActions.resetForm({ values: formValues });
          goBack();
        }
      }
    );
  };

  return (
    <Formik
      innerRef={formRef}
      initialValues={getCreatePricesInitialValues(product.id)}
      validate={validatePriceSchema}
      onSubmit={createPrices}
    >
      {({ values, submitForm, isSubmitting, errors }) => {
        return (
          <Fragment>
            <MenuNavHeader
              label={product.name}
              customClasses={classes.navHeader}
              action={{
                onClick: submitForm,
                copy: `Create price${values.prices.length > 1 ? "s" : ""}`,
                disabled: !isEmpty(errors),
                loading: isSubmitting
              }}
            />
            <div className={classes.priceList}>
              <ProductPriceFormList product={product} name="prices" />
            </div>
            {!hidePadder && <Padder theme="visible" />}
          </Fragment>
        );
      }}
    </Formik>
  );
};

const mapStateToProps = (state, otherProps) => {
  const {
    applicationUUID,
    merchantAccountUUID
  } = getCtxAppAndMerchantAccountUUID(state, otherProps);
  return {
    ...getCtxAppResourceAndIDs(state, applicationUUID),
    applicationUUID,
    merchantAccountUUID
  };
};

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(
    {
      createMerchantAccountPrices
    },
    dispatch
  )
});

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(ProductNewPriceForm)
);
